import { SHOW, HIDE } from './busy-indicator-actions';

const defaultState = {
    callCounter: 1,
    message: 'Loading...'
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case SHOW:
        return { ...state,
            callCounter: state.callCounter + 1
        };
    case HIDE:
        return { ...state,
            callCounter: state.callCounter > 0 ? state.callCounter - 1 : 0
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./components/busy-indicator/busy-indicator-reducer.js